import React from 'react';

const ErrorScreen = ({ children }) => <div className="error-screen">{children}</div>;

export default ErrorScreen;
